import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FieldComponent } from '../field/field.component';
import { ProvidehttpService } from '../providehttp.service';
import { ServiceStock } from '../service-stock.service';
@Component({
  selector: 'app-buttongroup',
  templateUrl: './buttongroup.component.html',
  styleUrls: ['./buttongroup.component.css']
})
export class ButtongroupComponent extends FieldComponent implements OnInit {
  @Input('fieldName') fieldName: string;
  @Input('staticOptions') staticOptions: any = [];
  @Input('doubleClickReq') doubleClickReq: boolean = false;
  @Output('buttonClick') buttonClick = new EventEmitter<string>();
  @Output('buttonDblclick') buttonDblclick = new EventEmitter<string>();
  
  timer: any;
  delay = 250;
  preventSingleClick = false;
  public selectedList;


  
  constructor(services: ServiceStock) {
    super(services);
  }
  ngOnInit() {
    if (this.customClass == "" || this.customClass == undefined) {
      this.customClass = "btn btn-primary";
    }
    this.staticOptions= JSON.parse(this.staticOptions);
      }
  
  public onSelectDropdown(list) {
    this.selectedList=list;
    this.fieldName=list.text;
   this.onClick(event);

     }
  
  onClick(event) {
    if (!this.doubleClickReq) {
      this.buttonClick.emit(this.selectedList);
    } else {
      this.timer = setTimeout(() => {
        if (!this.preventSingleClick) {
          this.buttonClick.emit(this.selectedList);
        }
        this.preventSingleClick = false;
      }, this.delay);
    }
  }

  onDoubleClick(event) {
    if (this.doubleClickReq) {
      clearTimeout(this.timer);
      this.preventSingleClick = true;
      this.buttonDblclick.emit(this.selectedList);
    }
  }
 

 }








